import { base_url } from "Backend/api";
import { resolveStoreOrdersCount } from "./storeOrdersCount";

export async function enrichMarketsWithOrdersCount(markets, token) {
  const list = Array.isArray(markets) ? markets : [];
  const headers = {
    Accept: "application/json",
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
  };

  const enriched = await Promise.all(
    list.map(async (m) => {
      const baseCount = resolveStoreOrdersCount(m);
      if (!m?.slug) return { ...m, _orders_count_normalized: baseCount };

      try {
        const res = await fetch(`${base_url}/api/markets/${encodeURIComponent(m.slug)}`, {
          headers,
        });
        const data = await res.json();
        const detail = data?.data || {};
        const detailCount = resolveStoreOrdersCount(detail);
        return {
          ...m,
          _orders_count_normalized: Math.max(baseCount, detailCount),
        };
      } catch {
        return { ...m, _orders_count_normalized: baseCount };
      }
    })
  );

  return enriched;
}
